import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the MonthPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'month',
})
export class MonthPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return value.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/pipes/month/month.ts